import React, { useState } from "react";
import { TextField, Button, Box, Typography } from "@mui/material";
import { useSaveGrowwApikeysMutation } from "../../../slices/gowwApiSlices";
import { useSelector } from "react-redux";
import toast, { Toaster } from "react-hot-toast";
const ApiKeyForm = () => {
      const { userInfo } = useSelector((state) => state.auth);
  const { darkmode } = useSelector((state) => state.darkmode);

  const userId = userInfo?._id || localStorage.getItem("userId");

  const [apiKey, setApiKey] = useState("");
  const [secretKey, setSecretKey] = useState("");

  const [saveGrowwApikeys] = useSaveGrowwApikeysMutation();

const handleSubmit = async () => {
  console.log("Submit clicked");

  try {
    await saveGrowwApikeys({
      userId,
      apiKey,
      secretKey,
    }).unwrap();
     toast.success("Groww API connected successfully");

 
  } catch (err) {
    toast.error(
     err?.data?.error || 
      err?.data?.message || 
      "Failed to connect Groww"
    );
  }
};

  return (
    <>
    <Toaster position="top-right" />
    <Box
      // component="form"
      // onSubmit={handleSubmit}
      sx={{
        display: "flex",
        flexDirection: "column",
        maxWidth: 500,
        margin: "0 auto",
        gap: 2,
        padding: 3,
        boxShadow: 3,
        borderRadius: 2,
        backgroundColor: darkmode? "#0a0a0a" : "#ffffff",
        color: darkmode ? "#ffffff" : "#000000",
        mt: { xs: 2, sm: 4 },
        mb:3
        
      }}
      
      >
      <Typography variant="h6" sx={{ textAlign: "center" }}>
        Groww
      </Typography>

      <TextField
        label="API Key"
        value={apiKey}
        onChange={(e) => setApiKey(e.target.value)}
        required
        sx={{
          input: {
            color: darkmode ? "#fff" : "#000",
          },
          label: {
            color: darkmode ? "#aaa" : "#555",
          },
          "& .MuiOutlinedInput-root": {
            "& fieldset": {
              borderColor: darkmode ? "#444" : "#ccc",
            },
            "&:hover fieldset": {
              borderColor: "#1976d2",
            },
          },
        }}
        />

      <TextField
        label="Secret Key"
        type="password"
        value={secretKey}
        onChange={(e) => setSecretKey(e.target.value)}
        required
        sx={{
          input: {
            color: darkmode ? "#fff" : "#000",
          },
          label: {
            color: darkmode ? "#aaa" : "#555",
          },
          "& .MuiOutlinedInput-root": {
            "& fieldset": {
              borderColor: darkmode ? "#444" : "#ccc",
            },
            "&:hover fieldset": {
              borderColor: "#1976d2",
            },
          },
        }}
        />

   <Button variant="contained" onClick={handleSubmit}   className="gold-btn"
>
  Submit
</Button>
    </Box>
        </>
  );
};

export default ApiKeyForm;





